import $ from 'jquery';

$(window).on('load', () => {
  const contactsItems = $('.contact-us__option');
  const contactsBlocks = $('.contact-us__block');
  const contactsLabel = $('.contact-us__label');
  const contactsInformation = document.querySelector('.contact-us__information');
  const propertySelect = document.querySelector('.question-form__block .form__item--select[name="destination"]');
  const contactsPropertyName = document.querySelector('[name="property_name"]');

  function showItem(item) {
    setTimeout(() => {
      $(item).prev().css({ opacity: 0 }).remove();
      $(item).css({ opacity: 1 });
    }, 0);
  }

  $(propertySelect).on('change', function () {
    const propertyVal = $(this).val();
    $(contactsPropertyName).val(propertyVal);
  });

  $('.contact-us__item.has_term').last().addClass('active');
  contactsItems.first().addClass('active');
  contactsItems.on('click', function () {
    contactsItems.removeClass('active');
    $(this).addClass('active');

    const nextContentWrapper = this.nextElementSibling;
    const copyOfContent = nextContentWrapper.cloneNode(true);
    contactsInformation.appendChild(copyOfContent);

    showItem(copyOfContent);

    const propertyName = $(this).text();

    const options = propertySelect.querySelectorAll('option');

    options.forEach((el) => {
      if (el.value == propertyName || propertyName.includes(el.value)) {
        if (propertyName.includes(el.value)) {
          const str = propertyName;
          const newStr = str.slice(0, el.value.length);
          propertySelect.value = newStr;
          contactsPropertyName.value = newStr;
          return;
        }
        propertySelect.value = propertyName;
        contactsPropertyName.value = propertyName;
      }

      if (propertyName === 'Reefhouse Resort & Marina') {
        propertySelect.value = 'Reefhouse Key Largo';
        contactsPropertyName.value = 'Reefhouse Key Largo';
      }
    });
  });

  contactsLabel.each(function () {
    const hasPrev = $(this).prev().hasClass('contact-us__label');
    const hasLastActive = $(this).prev().hasClass('active');
    const hasNext = $(this).next().hasClass('contact-us__label');
    if (hasNext || hasPrev || hasLastActive) {
      $(this).remove();
    }
  });

  function scrollToBlock(elem) {
    const wrapper = document.querySelector('.simplebar-content-wrapper');
    const contactOption = document.querySelector(`.contact-us__option[data-hash="${elem}"]`);
    if (contactOption) {
      const targetScroll = contactOption.offsetTop;
      wrapper.scrollTo({
        top: targetScroll - 285,
        behavior: 'smooth',
      });
    }
  }

  try {
    const prevUrl = document.referrer;
    let prevUrlPart = prevUrl.split('/').slice(3, 4)[0];

    const optionsBtns = document.querySelectorAll('.contact-us__option');

    const currentHashByDefault = document.querySelector('.contact-us__option--main');
    currentHashByDefault.click();

    for (let i = 0; i < optionsBtns.length; i++) {
      const { hash } = optionsBtns[i].dataset;
      const hashPart = hash.replace(/-/g, ' ');
      prevUrlPart = prevUrlPart.replace(/-/g, ' ');

      if (prevUrlPart.includes('opal grand')) {
        const currentHash = document.querySelector('.contact-us__option[data-hash="10929"]');
        currentHash.click();

        // eslint-disable-next-line no-undef
        if ($(window).width() < breakpoints.tablet) {
          currentHash.scrollIntoView({ block: 'start' });
        } else {
          setTimeout(() => {
            scrollToBlock(hash);
          }, 1500);
        }

        return;
      }

      if (prevUrlPart.includes('contact us')) {
        const currentHash = document.querySelector('.contact-us__option--main');
        currentHash.click();

        // eslint-disable-next-line no-undef
        if ($(window).width() < breakpoints.tablet) {
          currentHash.scrollIntoView({ block: 'start' });
        } else {
          setTimeout(() => {
            scrollToBlock(hash);
          }, 1500);
        }

        return;
      }

      if (hashPart.includes(prevUrlPart)) {
        contactsItems.removeClass('active');
        const currentHash = document.querySelector(`.contact-us__option[data-hash="${hash}"]`);
        currentHash.click();

        // eslint-disable-next-line no-undef
        if ($(window).width() < breakpoints.tablet) {
          currentHash.scrollIntoView({ block: 'start' });
        } else {
          setTimeout(() => {
            scrollToBlock(hash);
          }, 1500);
        }
        return;
      }
    }
  } catch {
    if (contactsItems.length) {
      const activeElText = contactsItems.first().text();
      propertySelect.value = activeElText;
      contactsPropertyName.value = activeElText;
    }
    const nextContentWrapper = document.querySelector('.contact-us__option--main');

    if (nextContentWrapper !== null) {
      const copyOfContent = nextContentWrapper.nextElementSibling.cloneNode(true);
      contactsInformation.appendChild(copyOfContent);
      showItem(copyOfContent);
    }

    if (contactsInformation !== null) {
      $(contactsInformation).find(contactsBlocks).css({ opacity: 1 });
    }
  }
});
